import { render, staticRenderFns } from "./BouquetType.vue?vue&type=template&id=1d8a8996&scoped=true"
import script from "./BouquetType.vue?vue&type=script&lang=js"
export * from "./BouquetType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8a8996",
  null
  
)

export default component.exports